import React from 'react';
import { useSelector } from 'react-redux';
import { selectEventCategoryPreServiceGroup } from '@features/eventDetail/slices/eventDetailClientSlice';
import ServiceLineTypePreServiceCart from '@features/subscriptions/components/ServiceLine/ServiceLineTypePreServiceCart';

interface ServiceListTypePreServiceProps {
  serviceGroupId: number;
  eventId: number;
  labelMinWidth?: string;
  disableServiceNotUpdatable?: boolean;
  disableServiceInvoiced?: boolean;
}

const ServicesListTypePreService = ({
  serviceGroupId,
  eventId,
  labelMinWidth,
  disableServiceInvoiced,
  disableServiceNotUpdatable,
}: ServiceListTypePreServiceProps) => {
  const serviceGroup = useSelector(selectEventCategoryPreServiceGroup(serviceGroupId));

  return (
    <div>
      {serviceGroup.services.filter(service => service).map(service => {
        const inputProps = {
          name: `group_${serviceGroup._idMso}.service_${service._idMso}`,
          labelMinWidth,
          disabled: disableServiceNotUpdatable && service.updatable && disableServiceInvoiced && service.invoiced,
          dataQa: `subscriptions-preService-input-group_${serviceGroup._idMso}.service_${service._idMso}`,
        };

        return (
          <ServiceLineTypePreServiceCart
            key={service._idMso}
            serviceId={service._idMso}
            eventId={eventId}
            {...inputProps}
          />
        );
      })}
    </div>
  );
};

export default ServicesListTypePreService;
